import { Component, Prop, h, Element, Listen, State } from "@stencil/core";
import { IconsMapping } from "../../utils/icons-mapping";
import { Prompt, PromptResponse } from "../../utils/prompt";
import { ExternalServices } from "../common/external-services";
import { PIAModel } from "../common/model";

@Component({
  tag: "gx-pia-container",
  styleUrl: "pia-container.scss",
  shadow: true
})
export class PiaContainer {
  @Prop() model:PIAModel.Model;
  @Prop() token:string;
  @Prop() showCompletion:boolean;
  @Prop() promptFromClient:boolean;
  @State() isProcessing:boolean = false;
  @Element() element:HTMLElement;

  private showAlert:boolean = false;
  private alertTitle:string;
  private alertMessage:string;
  private alertType: "error" | "notice";

  private defaultQuickMessages = [
    "Ok, let's do it!",
    "Ok, I'm working on it..."
  ]

  private defaultResponseMessages = [
    "You can see the result now!"
  ]

  private _getRandomElement(array:any[]):any{
    return array[Math.floor(Math.random() * array.length)]
  }

  @Listen('send')
  async sendHandler(event:CustomEvent<string>){
    if (!!event.detail){
      this.model.messages.push({        
        text: event.detail,
        type: "prompt",
      });
      this.model.messages.push({        
        text: this._getRandomElement(this.defaultQuickMessages),
        type: "completion",
      });
      this.isProcessing = true;

      let text = "";
      if (this.promptFromClient){
        text = await this._executePrompt(event);
      }
      else{
        text = await this._requestPrompt(event);
      }

      if (!!text){
        this.model.messages.push({
          text: this.showCompletion ? text : this._getRandomElement(this.defaultResponseMessages),
          type: "completion",
        });   
        
        this.alertTitle = "";
        this.alertMessage = ""
        this.showAlert = false;
      }
      else{
        this.alertTitle = "Empty response";
        this.alertMessage = "Provider response is empty."
        this.alertType = "notice";
        this.showAlert = true;
      }
      
      this.isProcessing = false;
    }
  }

  //Execute prompt from client
  private async _executePrompt(event){
    const response:PromptResponse = await Prompt.prompt(event.detail, this.model.documentData?.type, this.token);  
    let text = "";
    if (response.success){
      if (!!response.text){
        console.log(response.text);
        text = response.text.replace(/\\\\/g, '\\');
        text = text.replace(/\\n/g, '\n');
        text = text.replace(/\\t/g, '\t');
        console.log(text);       
        ExternalServices.executeAction("modify", this.model.documentData?.typeGuid, this.model.documentData?.name, text); 
      }
    }
    else{
      this.alertTitle = "Request failed";
      this.alertMessage = response.providerResponse;
      this.alertType = "error";
      this.showAlert = true;
    }

    return text;
  }

  //Execute prompt from BL
  private async _requestPrompt(event){
    return await ExternalServices.executeRequest("", this.model.documentData?.type, this.model.documentData?.typeGuid, this.model.documentData?.name, event.detail, this.token); 
  }

  private _renderAlert(){
    if (this.showAlert){
      return <gxg-alert 
        active = {true}
        activeTime = "regular"
        fullWidth = {true}
        title = {this.alertTitle}
        type = {this.alertType} 
      >
        {this.alertMessage}
      </gxg-alert>
    }
  }

  private _renderMessages(){
    let elements:any[] = [];
    this.model.messages.forEach(message => {
      elements.push(
        <gx-pia-message 
          text={message.text}
          align={message.type == 'prompt' ? "right" : "left" }
        />
      )
    });
    return elements;
  }

  private _renderDocumentData(){
    if (!!this.model.documentData && !!this.model.documentData.type && this.model.documentData.name){
      return (<div class="documentData">
          <gxg-icon size="regular" type={IconsMapping.getIcon(this.model.documentData.type)} color="auto" class="documentDataContent"/>
          <gxg-text class="documentDataContent">
            {`${this.model.documentData.type}:${this.model.documentData.name}`}
          </gxg-text>
        </div>);
    }
  }

  private _renderProcessing(){
    if (this.isProcessing){
      return <gxg-text class="processingText">Processing..</gxg-text>
    }
  }

  componentDidRender(){    
    setTimeout(() => {
      let gxgScroll = this.element.shadowRoot.querySelector("gxg-scroll").shadowRoot.querySelector(".gxg-scroll");
      gxgScroll.scrollTop = gxgScroll.scrollHeight+100;
    }, 100);    
  }

  render() {
    return [
      this._renderAlert(),
      this._renderDocumentData(),
      <div class="piaContainer">        
        <gxg-scroll max-height="85vh">
          {this._renderMessages()}
        </gxg-scroll>
        {this._renderProcessing()}
        <gx-pia-send-control />        
      </div>]
    ;
  }
}
